export default __webpack_public_path__ + "static/IAMProxyIngestRole_Policies-b595a00c6cf48a094bc78c1111f2056f.png";